import { fetchCurrencyConversionRate } from 'actions/GeoActions'
import type { DefinedAppAction } from 'actions/types/ActionTypes'
import type { ThunkAction } from 'redux-thunk'

/**
 * Loyalty: how many units of a currency one Australian dollar buys, at svc-fx's v2 rates, the ones
 * svc-order prices its A$ margin tolerance cap with. Resolves undefined when the rate can't be fetched.
 */
function fetchAudConversionRate(
  currencyCode: string,
): ThunkAction<Promise<number | undefined>, App.State, undefined, DefinedAppAction> {
  return dispatch => new Promise((resolve) => {
    dispatch(fetchCurrencyConversionRate('AUD', currencyCode, (result) => {
      resolve(result.status === 'success' ? result.data : undefined)
    }))
  })
}

export default fetchAudConversionRate
